export default {
  'dashboard.totalUsers': 'Total Active Users',
  'dashboard.collectedEmis': 'Collected EMIs',
  'dashboard.closedHps': 'Closed HPs',
  'dashboard.totalLoan': 'Total Loan Amount',
  'dashboard.vehiclesAvailable': 'Vehicles Available',
  'dashboard.vehiclesSold': 'Vehicles Sold',
  'dashboard.handLoans': 'Hand Loans',
  'dashboard.seizedHps': 'Seized HPs',
  'dashboard.overview': 'Overview',
  'dashboard.exportReport': 'Export report',
  'dashboard.overviewSub': 'Balances and throughput for {{range}}. Open any card for ledger detail and drill-downs.',
  'dashboard.collectionsTrend': 'Collections trend',
  'dashboard.collectionsTrendSub': 'EMI receipts & late charges by month — {{range}}',
  'dashboard.portfolioSplit': 'Portfolio split',
  'dashboard.topBorrowers': 'Top borrowers by outstanding',
  'dashboard.quickActions': 'Quick actions',
  'dashboard.newFinance': 'New finance',
  'dashboard.newHandLoan': 'New hand loan',
  'dashboard.consultancyDesk': 'Consultancy desk',
  'dashboard.collected': 'Collected',
  'dashboard.noData': 'No data in this period',
  'dashboard.cashBankFlows': 'Cash & bank flows',
  'dashboard.cashBankFlowsSub': 'Money in and out by channel — {{range}}',

  'master.title': 'Dashboard',
  'master.financeIncome': 'Finance income',
  'master.totalRevenue': 'Total revenue',
  'master.interestCollectedHint': 'Interest collected',
  'master.revenueHint': 'Interest + late fees collected',
  'master.interestWithYtdHint': 'Period interest + late fees + YTD opening seed',
  'master.portfolioHint': 'Active portfolio still due',
  'master.borrowersHint': 'borrowers',
  'master.openingCash': 'Cash in hand',
  'master.openingBank': 'Bank balance',
  'master.openingBooksHint': 'From opening books / cutover',
  'master.liveCashHint': 'Opening cash + collections − loans, expenses & advances',
  'master.liveBankHint': 'Opening bank + credits − debits since cutover',
  'master.financeProfit': 'Finance profit',
  'master.profitFormula': 'Revenue − expenses',
  'master.netFormula': 'Finance revenue + consultancy profit − expenses',
  'master.emiCollected': 'Total EMI collected',
  'master.cashBankHint': 'Cash taken / bank credit = collections in. Cash given / bank debit = loans disbursed out.',
  'master.financeSectionHint': 'Revenue = interest + late fees collected (+ YTD seed when applicable). Profit = revenue − expenses. EMI collected is loan cash only (principal + interest in receipts).',
  'master.consultancySectionHint': 'Vehicle sales desk — revenue, cost of goods, and profit for the selected period.',
  'master.consultancyProfit': 'Consultancy profit',
  'master.expenses': 'Total expenses',
  'master.netAccounting': 'Net profit',
  'master.tabCombined': 'Combined',
  'master.tabFinance': 'Finance',
  'master.tabConsultancy': 'Consultancy',
  'master.incomeVsExpenses': 'Revenue vs expenses',
  'master.monthlyCollections': 'Monthly collections & interest',
  'master.revenueVsProfit': 'Revenue vs profit',
  'master.spendByCategory': 'Spend by category',

  'accounts.title': 'Accounts & migration',
  'accounts.subtitle': 'Set cutover date and opening balances for your financial year.',
  'accounts.howtoTitle': 'Go-live in 3 steps',
  'accounts.howto1': 'Set cutover date and opening balances (cash, bank, capital, loans receivable).',
  'accounts.howto2': 'Migrate each active finance / hand loan with outstanding + next due (not full EMI history).',
  'accounts.howto3': 'From cutover onward, record new payments and expenses only in this software.',
  'accounts.tabOpening': 'Opening books',
  'accounts.tabMigrateFinance': 'Migrate finance',
  'accounts.tabMigrateHand': 'Migrate hand loan',
  'accounts.tabMigrated': 'Migrated list',
  'accounts.openingHeading': 'Opening balances as of cutover',
  'accounts.cutoverDate': 'Cutover / go-live date',
  'accounts.cutoverHint': 'Books and migrated loans start from this date. Use Working date in the navbar for daily posting.',
  'accounts.portfolioCheck': 'Migrated loans outstanding at cutover (open loans only)',
  'accounts.booksOutstanding': 'Books loans receivable',
  'accounts.mismatchHint': 'Does not match — use “Fill from portfolio” or check loan entries',
  'accounts.matchedHint': 'Matches portfolio',
  'accounts.notes': 'Migration notes',
  'accounts.notesPlaceholder': 'e.g. Migrated from physical books / old software on …',
  'accounts.saveOpening': 'Save opening books',
  'accounts.fillFromPortfolio': 'Fill loans receivable from portfolio',
  'accounts.migrateFinanceTitle': 'Migrate existing finance facility',
  'accounts.migrateFinanceHint': 'Enter the loan as it stands today: outstanding principal, remaining EMIs, next due.',
  'accounts.migrateHandTitle': 'Migrate existing hand loan',
  'accounts.migrateHandHint': 'Bring an active hand loan with outstanding principal and interest due at cutover.',
  'accounts.migrateWarning': 'Do not re-enter every old EMI. Only outstanding + schedule remaining. Closed loans stay in your old books.',
  'accounts.saveMigratedFinance': 'Save migrated finance loan',
  'accounts.saveMigratedHand': 'Save migrated hand loan',
  'accounts.migratedFinance': 'Migrated finance facilities',
  'accounts.migratedHand': 'Migrated hand loans',
  'accounts.noneMigrated': 'No migrated facilities yet.',
  'accounts.openErpFy': 'Open Finance ERP',
  'accounts.erpSharedHint': 'Cash, bank, capital, and other FY opening balances are the same fields as Finance ERP → Financial year. Saving here updates that FY. Use ERP for trial balance, P&L, and year close.',
  'accounts.localOpeningHint': 'Opening balances are saved for this ledger book. Finance ERP sync is available when you have finance or audit access.',
  'accounts.fyBalancesHeading': 'Financial year opening (shared with ERP)',
  'accounts.ytdHeading': 'Optional mid-year P&L seeds (Accounts only)',

  'customers.title': 'Customers',
  'customers.addHint': 'Add finance cases or hand loans — each facility rolls up to a borrower here with live balances.',
  'customers.financeDesk': 'Finance desk',
  'customers.handLoans': 'Hand loans',
  'customers.backOverview': 'Back to overview',
  'customers.totalPrincipal': 'Total principal',
  'customers.amountCollected': 'Amount collected',
  'customers.principalOutstanding': 'Principal outstanding',
  'customers.totalDue': 'Total amount due',
  'customers.pageTitle': 'Customers',
  'customers.exportTitle': 'Customers Report',
  'customers.filterAll': 'All',
  'customers.filterFinance': 'Finance',
  'customers.filterHand': 'Hand loans',
  'customers.filterLoanType': 'Loan type',
  'customers.filterFileStatus': 'File status',
  'customers.filterStatusAll': 'All files',
  'customers.filterActive': 'Active',
  'customers.filterClosed': 'Closed',
  'customers.badgeActive': 'Active',
  'customers.badgeClosed': 'Closed',

  'customer.tabOverview': 'Overview',
  'customer.tabHistory': 'History',
  'customer.tabAlerts': 'Alerts',
  'customer.accountSummary': 'Account summary',
  'customer.overdueDays': 'Overdue days',
  'customer.unpaidOverdueDays': 'Unpaid overdue days',
  'customer.calculatedPenalty': 'Calculated penalty',
  'customer.loggedLateFees': 'Late fees due',
  'customer.lateFeesDue': 'Overdue charges due',
  'customer.lateFeesBalance': 'Overdue balance',
  'customer.noOverdue': 'No overdue days on record for this customer.',
  'customer.viewMissedDates': 'View missed dates',
  'customer.smsReminder': 'SMS reminder',
  'customer.cashIn': 'Cash in',
  'customer.cashCollected': 'Cash collected',
  'customer.interestRecognized': 'Interest recognized',
  'customer.ledgerInterest': 'Interest (ledger splits)',
  'customer.nextInstallment': 'Next installment',
  'customer.noUpcomingEmi': 'No upcoming EMI – check tenor and EMI on each facility below.',
  'customer.facilityTable': 'Loan facilities — Collect EMIs',
  'customer.facilityTableSub': 'Months, EMI amount, and collect for each loan',
  'customer.installmentSchedule': 'Full installment schedule',
  'customer.upcomingCashflow': 'Upcoming cashflow by month',
  'customer.paymentHistory': 'Payment history',
  'customer.alerts': 'Alerts',
  'customer.recordPayment': 'Collect EMIs',
  'customer.collectEmis': 'Collect EMIs',
  'customer.emisComplete': 'EMIs complete',
  'customer.collectionCol': 'Collect',
  'customer.closeFile': 'Close file',
  'customer.refinance': 'Refinance',
  'customer.markSeized': 'Mark seized',
  'customer.due': 'Due',
  'customer.facility': 'Facility',
  'customer.kind': 'Kind',
  'customer.note': 'Note',
  'customer.lateFee': 'Late fee',
  'customer.balanceAfter': 'Balance after',
  'customer.payoff': 'Payoff',

  'finance.newApplication': 'New application',
  'finance.noRows': 'No rows match your search.',
  'finance.noRecords': 'No finances yet — use New application to open the dedicated application page.',
  'finance.regHa': 'Reg / HA',
  'finance.customer': 'Customer',
  'finance.emi': 'EMI',
  'finance.currentFinances': 'Current finances',
  'finance.editApplication': 'Edit application',
  'finance.stepVehicle': 'Vehicle',
  'finance.stepFinancial': 'Financial',
  'finance.stepParties': 'Parties',
  'finance.backToList': 'Back to list',
  'finance.saveApplication': 'Save application',

  'loans.borrower': 'Borrower',
  'loans.interest': 'Interest',
  'loans.term': 'Term',
  'loans.type': 'Type',
  'loans.newApplication': 'New application',
  'loans.noRows': 'No rows match your search.',
  'loans.noRecords': 'No hand loans yet — use New application to open the dedicated application page.',
  'loans.currentHandLoans': 'Current hand loans',
  'loans.stepBorrower': 'Borrower',
  'loans.stepFacility': 'Facility',
  'loans.repaymentEmi': 'EMI',
  'loans.repaymentShort': 'Short term',
  'loans.saveApplication': 'Save application',

  'reports.title': 'Reports',
  'reports.subtitle': 'Finance and hand-loan activity for the selected period.',
  'reports.loanType': 'Loan type',
  'reports.serviceLine': 'Service line',
  'reports.sortBy': 'Sort by',
  'reports.financeCreated': 'Finance created',
  'reports.handCreated': 'Hand loans created',
  'reports.financeClosed': 'Finance closed',
  'reports.handClosed': 'Hand loans closed',
  'reports.financeSeized': 'Finance seized',
  'reports.collections': 'Collections',
  'reports.outstandingOverdue': 'Outstanding & overdue',
  'reports.financeNew': 'Finance new',
  'reports.financeClosedShort': 'Finance closed',
  'reports.seized': 'Seized',
  'reports.handNew': 'Hand loan new',
  'reports.handClosedShort': 'Hand closed',
  'reports.collected': 'Collected',
  'reports.lateFees': 'Late fees',
  'reports.openHps': 'Open HPs',
  'reports.amtDue': 'Amt due',
  'reports.regHa': 'Reg / HA',
  'reports.lateFee': 'Late fee',
  'reports.menuLead': 'Choose a report. It opens on its own page, where you can download Excel or PDF.',
  'reports.allReports': 'All reports',
  'reports.downloadHint': 'Use Export File on this page to download Excel or PDF.',
  'reports.groupBooks': 'Open books',
  'reports.groupPeriod': 'Selected period',
  'reports.groupLedgers': 'All ledgers',
  'reports.periodSummary': 'Period summary',
  'reports.consolidated': 'Consolidated report',
  'reports.overdue': 'Overdue',
  'reports.outstanding': 'Outstanding balances',
  'reports.descPeriod': 'Counts and amounts for the selected period.',
  'reports.descConsolidated': 'Receipts, interest, expenses, and cash flow across ledgers.',
  'reports.descFinanceCreated': 'Finance files opened in this period.',
  'reports.descHandCreated': 'Hand loans opened in this period.',
  'reports.descFinanceClosed': 'Finance files closed in this period.',
  'reports.descHandClosed': 'Hand loans closed in this period.',
  'reports.descSeized': 'Vehicles seized in this period.',
  'reports.descCollections': 'Collections posted in this period.',
  'reports.descLateFees': 'Late fees collected in this period.',
  'reports.descOutstanding': 'Amount still to collect on open loans.',
  'reports.descOverdue': 'Borrowers whose payment is already late.',
  'reports.noOverdue': 'No overdue borrowers.',
  'reports.noLateFees': 'No late fees in this period.',

  'employees.title': 'Employees & Payroll',
  'employees.subtitle': 'Manage staff, salaries and advances. Payroll figures for {{range}}.',
  'employees.addEmployee': 'Add employee',
  'employees.activeStaff': 'Active staff',
  'employees.salaryPaid': 'Salary paid',
  'employees.advancesGiven': 'Advances given',
  'employees.outstandingAdvances': 'Outstanding advances',
  'employees.payrollReport': 'Payroll Report',
  'employees.salary': 'Salary',
  'employees.advances': 'Advances',
  'employees.basic': 'Basic',
  'employees.bonus': 'Bonus',
  'employees.netPay': 'Net pay',
  'employees.method': 'Method',

  'expenses.title': 'Expenses',
  'expenses.subtitle': 'Track operating spend for {{range}}.',
  'expenses.recordExpense': 'Record expense',
  'expenses.categories': 'Categories',
  'expenses.totalSpend': 'Total spend',
  'expenses.category': 'Category',
  'expenses.vendor': 'Vendor',
  'expenses.description': 'Description',
  'expenses.paidBy': 'Paid by',
  'expenses.paymentMethod': 'Payment method',
  'expenses.addCategory': 'Add category',
  'expenses.spendByCategory': 'Spend by category',
  'expenses.expenseReport': 'Expense Report',

  'consultancy.title': 'Consultancy',
  'consultancy.vehicles': 'Vehicle inventory',
  'consultancy.investment': 'Investment',
  'consultancy.revenue': 'Revenue',
  'consultancy.profit': 'Profit',
  'consultancy.loss': 'Loss',
  'consultancy.buyStock': 'Add stock',
  'consultancy.sellStock': 'Sell from stock',
  'consultancy.available': 'Available',
  'consultancy.sold': 'Sold',
  'consultancy.all': 'All',
  'consultancy.service': 'Service',
  'consultancy.transactionHistory': 'Transaction history',
  'consultancy.filtersSort': 'Filters and sort',
  'consultancy.operationsDesk': 'Operations desk',
  'consultancy.history': 'History',

  'portal.dueNow': 'Due now',
  'portal.paid': 'Paid',
  'portal.schedule': 'Installment schedule',
  'portal.payments': 'Payment history',
  'portal.totalLoan': 'Total loan',
  'portal.lateFee': 'Late fee',
  'portal.lateDays': 'Late days',
  'portal.paidEmis': 'Paid EMIs',
  'portal.pendingEmis': 'Pending EMIs',
  'portal.yourAccount': 'Your account',
  'portal.signOut': 'Sign out',
  'portal.allLoans': 'All loans',

  'navbar.latePayments': 'Late payments',
  'navbar.noLatePayments': 'No late payments',
  'navbar.notifications': 'Notifications',
  'navbar.account': 'Account',
  'navbar.darkMode': 'Dark mode',
  'navbar.lightMode': 'Light mode',

  'hub.title': 'Workspace home',
  'hub.subtitle': 'Every module in one place — open any card to manage finance, collections, reports, and settings.',
  'hub.allModules': 'All modules',
  'hub.modulesCount': 'modules',
  'hub.modulesAria': 'Application modules',
  'hub.backToModules': 'Back to modules',
  'hub.accountingSummary': 'Accounting summary',
  'hub.accountingTitle': 'P&L & cash flows',
  'hub.emiManagement': 'EMI management',
  'hub.paymentsCollections': 'Payments & collections',
  'hub.overdueManagement': 'Overdue management',
  'hub.ledgers': 'Ledgers',
  'hub.userManagement': 'User management',
  'hub.descOverview': 'Portfolio KPIs, collection trends, and quick actions for daily operations.',
  'hub.descAccounting': 'Combined P&L, finance income, consultancy profit, expenses, and cash flows.',
  'hub.descCustomers': 'Borrower profiles, loan schedules, EMI receipts, and account history.',
  'hub.descFinance': 'Create and manage hire-purchase finance facilities and disbursements.',
  'hub.descHandLoans': 'Short-term hand loans with flexible terms and collection tracking.',
  'hub.descEmi': 'Track due installments, record receipts, and manage flexible EMI schedules.',
  'hub.descPayments': 'Record collections, split cash and bank receipts, and view payment history.',
  'hub.descOverdue': 'Monitor late borrowers, overdue days, and penalty charges.',
  'hub.descAccounts': 'Opening books, cutover migration, and live cash and bank balances.',
  'hub.descReports': 'Day reports, portfolio snapshots, collections, and overdue summaries.',
  'hub.descAudit': 'Immutable activity log for logins, updates, and security events.',
  'hub.descErp': 'Trial balance, balance sheet, P&L, day book, journals, and reconciliation.',
  'hub.descConsultancy': 'Vehicle inventory desk — buy, sell, investment, and profit tracking.',
  'hub.descExpenses': 'Track business expenses by category with export and reporting.',
  'hub.descEmployees': 'Staff records, salary payments, advances, and payroll history.',
  'hub.descLedgers': 'Multi-book setup — create ledgers, assign logins, and switch books.',
  'hub.descUsers': 'Workspace owners, admins, roles, and permission management.',
  'hub.descSettings': 'Company profile, banks, SMS, payments, subscription, and appearance.',
  'hub.statBorrowers': 'Borrowers',
  'hub.statNetProfit': 'Net profit',
  'hub.statCollectedMonth': 'This month',
  'hub.statActiveFinance': 'Finance records',
  'hub.statActiveLoans': 'Hand loans',
  'hub.statEmiDue': 'EMI due',
  'hub.statOverdue': 'Overdue',
  'hub.statActivityLog': 'Activity',
  'hub.statViewLog': 'View log',
  'hub.statBooks': 'Books',
  'hub.statFullSuite': 'Full suite',
  'hub.statEntries': 'Entries',
  'hub.statStaff': 'Staff',
  'hub.statAccess': 'Access',
  'hub.statTeamRoles': 'Team & roles',
  'hub.statWorkspace': 'Workspace',
  'hub.statConfigure': 'Configure',
} as const;
